
import React, { useState, useContext, useEffect }from 'react';
import { useIonRouter, IonContent, IonHeader, IonFooter, IonTitle, IonToolbar, IonMenuButton, IonButtons, IonButton, IonItem, IonGrid, IonRow, IonCol, IonInput, IonLabel, IonPage, IonList, IonIcon, IonRefresher, IonRefresherContent, IonText } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { searchOutline } from 'ionicons/icons'; // Import the search icon
import { helpCircleOutline } from 'ionicons/icons';


//import { SelectDateRange } from '../components/SelectDateRange';
//import { Auth_ClientID_context } from '../../../storeState/auth_clientID_context'
import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';
import { App_Header } from '../components/App_Header';
//import { App_Footer } from '../components/App_Footer';

import '../../css/layout.css';
import { HotelSlide } from '../components/Tab_Hotels';
import { OrdersSlide } from '../components/Tab_Orders';
import { ProjectsSlides } from '../../zInternal_Features/merchant/components/Tab_Projects';
import { Client_Jobs } from '../components/Tab_Jobs';

import { User_Management } from '../components/user_management_services';
import { Helpdesk_Public } from '../../zInternal_Features/merchant/components/Modal_HelpChat_Public';

import { useHistory} from "react-router-dom";


 export function ClientHomePage (props) {

    let authClient_context = useContext(Auth_MerchantID_context);

    let [acctID, setAccountID ] = useState(authClient_context.acctID);
    let [employeeID, setEmployeeID ] = useState(authClient_context.employeeID);
    let [schema, setSchema ] = useState(authClient_context.schema);
    let [access, setAccessRights ] = useState(authClient_context.accessRights);
    let [sessionID, setSessionID ] = useState(authClient_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authClient_context.baseURL);

    let [hotelData, setHotelData] = useState(false);
    let [ordersData, setOrdersData] = useState(true);
    let [projectsData, setProjectsData] = useState(false);
    let [jobsData, setJobsData] = useState(false);

    let [color_hotels, setColor_hotels] = useState('clear')
    let [color_orders, setColor_orders] = useState('outline')
    let [color_projects, setColor_projects] = useState('clear')
    let [color_jobs, setColor_jobs] = useState('clear')

    let [managementService_hotel, setManagementService_hotel] = useState(false);

    let [searchTerm, setSearchTerm] = useState(null);

    let [viewHelpDeskModal, setViewHelpDeskModal] = useState(false);

    let history = useHistory();
    let router = useIonRouter();

    function hotelHandler()
    {
        setHotelData(true);
        setOrdersData(false);
        setProjectsData(false);
        setJobsData(false);

        setColor_hotels('outline');
        setColor_orders('clear');
        setColor_projects('clear');
        setColor_jobs('clear');


    }
    function ordersHandler()
    {
        setHotelData(false);
        setOrdersData(true);
        setProjectsData(false);
        setJobsData(false);

        setColor_hotels('clear');
        setColor_orders('outline');
        setColor_projects('clear');
        setColor_jobs('clear');

    }
    function projectsHandler()
    {
        setHotelData(false);
        setOrdersData(false);
        setProjectsData(true);
        setJobsData(false);

        setColor_hotels('clear');
        setColor_orders('clear');
        setColor_projects('outline');
        setColor_jobs('clear');

    }

    function jobsHandler()
    {
        setHotelData(false);
        setOrdersData(false);
        setProjectsData(false);
        setJobsData(true);

        setColor_hotels('clear');
        setColor_orders('clear');
        setColor_projects('clear');
        setColor_jobs('outline');

    }

    function handleSearch(e) {

        setSearchTerm(e.target.value);

      };


    const handleHomepage_zasava = () => {

        if (baseURL === "https://ghanaverified.com/") {
            window.location.href = "https://zasava.com";
            //history.push("https://zasava.com");

        } 
        else if (baseURL === "https://ghanaverifiedtest.com/") {
            window.location.href = "https://zasavatest.com";
           // history.push("https://zasavatest.com");
        }
  };

  function handleHomepage(event) {

    // alert(event);
    // alert(window.location.pathname)

        // history.push(event);
        router.push(event, 'forward', 'replace');
        //window.location = event;
    };

    function handleRefresh(event)
    {
        // Optional: Delay to show the spinner briefly
        setTimeout(() => {
            event.detail.complete();   // Stop the spinner
            window.location.reload();  // Reload the entire app
        }, 500);
    }

    useEffect(() => {

        if(props.data.source == 'online_application_register_completed')
        {
            jobsHandler();
        }

    }, [])
    //alert("IN MAIN PAGE");
     //alert (authClient_context.authenticated);
     //alert (authClient_context.biometric_fingerprint);
    // alert (authClient_context.device);
    //alert(authClient_context.accessRights);
    //alert(authClient_context.capability);
    //alert(authClient_context.feature);

    return (
            <React.Fragment>
            
            <IonContent fullscreen>

            <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
                <IonRefresherContent
                pullingText="Pull to refresh the app"
                refreshingSpinner="circles"
                refreshingText="Refreshing app..."
                />
            </IonRefresher>
            <IonHeader>
            <IonToolbar className="grid_header_componentSlides" color="dark">

            <IonGrid className='grid_header'>
                {authClient_context.authenticated != null && <IonRow>
                    <IonCol style={{ textAlign: 'left', color: 'white' }} size='4'>
                        <IonTitle >{authClient_context.employeeCompany}</IonTitle>
                    </IonCol>
                    <IonCol style={{ textAlign: 'left', color: 'white' }} size='6'>
                        <IonTitle >{authClient_context.employeeFirstName + ' ' + authClient_context.employeeLastName}</IonTitle>
                    </IonCol>
                    {authClient_context.initialSetup?.details?.step_1 == false && <IonCol className='gh_top_links_col_right' size='2'>
                        {/*<IonMenuButton className="custom-menu-button_initialSetup">M</IonMenuButton>*/}
                        <IonButtons>
                        <IonMenuButton className='flash-tutorial'></IonMenuButton>
                        </IonButtons>                            
                        </IonCol>}
                    {authClient_context.initialSetup?.details?.step_1 == true && <IonCol className='gh_top_links_col_right' size='2'>
                        <IonButtons>
                        <IonMenuButton ></IonMenuButton>
                        </IonButtons>
                        </IonCol>}
                </IonRow>}
                </IonGrid>
                </IonToolbar>
                <IonToolbar className="grid_header_componentSlides" color="dark">
                <IonGrid>
                    <IonRow>
                        <IonCol size = '3'>
                            <IonButton className= 'small-button-tabs' fill={color_hotels} onClick={() => hotelHandler()}> Hotel </IonButton>
                        </IonCol>
                        <IonCol size = '3'>
                            <IonButton className= 'small-button-tabs' fill={color_orders} onClick={() => ordersHandler()}> Orders </IonButton>
                        </IonCol>
                        <IonCol size = '3'>
                            <IonButton className= 'small-button-tabs' fill={color_projects} onClick={() => projectsHandler()}> ProService </IonButton>
                        </IonCol>
                        <IonCol size = '3'>
                            <IonButton className= 'small-button-tabs' fill={color_jobs} onClick={() => jobsHandler()}> Jobs </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
                </IonToolbar>
                </IonHeader>

                    {/*<BusinessTabs accountID= {acctID} employeeID={ employeeID } schemaName={schema} accessRights={access}/>*/}

                    {hotelData == true && <HotelSlide openModal={ hotelData } closeModal={() => setHotelData(false)}></HotelSlide>}
                    {ordersData == true && <OrdersSlide openModal={ ordersData } closeModal={() => setOrdersData(false)}></OrdersSlide>}   
                    {projectsData == true && <ProjectsSlides openModal={ projectsData } closeModal={() => setProjectsData(false)}></ProjectsSlides>}
                    {jobsData == true && <Client_Jobs openModal={ jobsData } closeModal={() => setJobsData(false)}></Client_Jobs>}

                    {managementService_hotel == true && <User_Management openModal={managementService_hotel} closeModal={() => setManagementService_hotel(false)}></User_Management>}
                    
                    {viewHelpDeskModal == true && <Helpdesk_Public openModal={viewHelpDeskModal} closeModal={() => setViewHelpDeskModal(false)}></Helpdesk_Public>}


                <IonFooter className='grid_footer'>
                        <IonGrid>
                            <IonRow>
                                <IonCol size='6'>
                                        <IonButton fill="clear" size='medium' onClick={() => setViewHelpDeskModal(true)}>
                                            <IonText>HELP</IonText>
                                            <IonIcon icon={helpCircleOutline} />
                                    </IonButton>
                                </IonCol>
                            {/*{(authClient_context.authenticated != null && (authClient_context.acctID == "U5" || authClient_context.acctID == "U6")) &&
                                    <IonCol className='gh_bottom_links_col_right' size='2'>
                                        <IonButton className='small_button' onClick={() => handleHomepage_zasava()}>Zasava</IonButton>
                                    </IonCol>
                                }*/}
                                <IonCol size='6'>
                                    <IonButton className="custom-public-button" fill={'clear'} onClick={() => handleHomepage('/home')}>
                                            <IonText style={{fontSize: '.5em'}}>PUBLIC</IonText>
                                    </IonButton>
                                </IonCol>
                            </IonRow>
                        </IonGrid>

                </IonFooter>

                </IonContent>
            </React.Fragment>

    );
};



export default ClientHomePage;

